"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useActionState } from "react";
import { LoaderIcon } from "lucide-react";
import { GoogleIcon } from "@/components/icons/google";
import { signinWithGoogle } from "../_actions";
import InputError from "@/components/input-error";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import ReferralCode from './referral-code';
export default function GoogleSigninButton(t0) {
  const $ = _c(14);
  const {
    className
  } = t0;
  const [state, action, loading] = useActionState(signinWithGoogle, undefined);
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== loading) {
    t2 = !loading ? <GoogleIcon /> : <LoaderIcon className="animate-spin" />;
    $[2] = loading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== loading || $[5] !== t1 || $[6] !== t2) {
    t3 = <Button type="submit" disabled={loading} className={t1} variant="outline">{t2}{" "}Google</Button>;
    $[4] = loading;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = state?.error;
  let t5;
  if ($[8] !== t4) {
    t5 = <InputError error={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Suspense><ReferralCode /></Suspense>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t5) {
    t7 = <form action={action}>{t3}{t5}{t6}</form>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}